// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"91f1e988","239":"ef70eefc","455":"cf40dfae"}[chunkId] + ".chunk.js";
};